import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-change-email.hbs';

var ChangeEmailView = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        email: '#email',
        password: '#password',
        load_spinner: '.loader',
        submit_btn: '.btn.btn-primary'
    },
    events: {
        'submit form': 'onSubmit',
        'keyup @ui.password': 'validate',
        'paste @ui.password': 'validate',
        'change @ui.password': 'validate',
        'mouseup @ui.password': 'validate',
        'keyup @ui.email': 'validate',
        'paste @ui.email': 'validate',
        'change @ui.email': 'validate',
        'mouseup @ui.email': 'validate',
    },
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    onRender: function () {
    },
    validate: function() {
        this.trigger('input');
        if (!this.ui.password.val() || !this.ui.email.val()) {
            this.ui.submit_btn.prop('disabled', true);
        } else if (this.ui.email.val() === this.model.get('email')){
            this.ui.submit_btn.prop('disabled', true);
        } else {
            this.ui.submit_btn.prop('disabled', false);
        }
    },
    onSubmit: function(e){
        var alertsCh = Radio.channel('alerts');
        e.preventDefault();
        this.ui.load_spinner.show();
        const email = this.ui.email.val();
        const password = this.ui.password.val();
        this.model.change_email(email, password).then(function(){
            this.closeDialog();
            alertsCh.request(
                'showAlert',
                { message: 'Successfully sent change request for ' + this.model.get('username') + '\'s email. Check email to activate new email address.',
                    messageType: 'success'});
        }.bind(this), function(err){
            this.ui.load_spinner.hide();
            var error_message;
            if (err) {
                if (err.responseJSON && err.responseJSON.errors) {
                    if (err.responseJSON.errors[0].detail) {
                        error_message = String(err.responseJSON.errors[0].title + ' ' + err.responseJSON.errors[0].detail);
                    }
                }
            }
            if (!error_message) {
                error_message = 'Failed to update ' + this.model.get('username');
            }
            this.showAlert('failure', 'Failed to update, ' + error_message);
            this.listenToOnce(this, 'input', function () {
                this.hideAlert();
            }.bind(this));
        }.bind(this));
    }
});
export default ChangeEmailView;

